import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setCustomTexts } from './custom-texts.actions';
export const customTexts = createReducer({}, on(setCustomTexts, (state, action) => {
    return action.customTexts;
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}));
